// @ts-nocheck
import React, { Component } from 'react';
import { inject } from "../../../stores/mobx-compat";

import PageHeader from '../../ui/PageHeader';
import Tabs from '../../ui/Tabs';
import Webhooks from './Webhooks';
import Emails from './Emails';
import EmailActivity from './EmailActivity';
import StopList from './StopList';
import Analytics from './Analytics';

class Reporting extends Component {
  state = { active: 'leads' };

  get items() {
    const list = [
      { value: 'leads', label: 'Leads Data' },
      { value: 'email-activity', label: 'Email Activity' },
      { value: 'webhooks', label: 'Webhooks' },
      { value: 'stoplist', label: 'Email Stop List' },
    ];
    if (this.props.store.auth.user.clientId === '-LdAFTqcw5zxWECiQK5-') {
      list.push({ value: 'analytics', label: 'Analytics' });
    }
    return list;
  }

  render() {
    const { active } = this.state;
    return (
      <>
        <PageHeader
          eyebrow="Reporting"
          title={<>What your visitors <em>actually</em> did.</>}
          sub="Lead data exports, webhook deliveries, and unsubscribe management."
        />
        <Tabs
          value={active}
          onChange={(v) => this.setState({ active: v })}
          items={this.items}
        />
        {active === 'leads' && <Emails />}
        {active === 'email-activity' && <EmailActivity />}
        {active === 'webhooks' && <Webhooks />}
        {active === 'stoplist' && <StopList />}
        {active === 'analytics' && <Analytics />}
      </>
    );
  }
}

export default inject('store')(Reporting);
